/**
 * Decode Html entities
 * @param {String} html
 */
export function decodeHtml(html = '') {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  if (typeof txt.remove === 'function') {
    txt.remove();
  }
  return txt.value;
}

// https://coderwall.com/p/0iz_zq/how-to-put-focus-at-the-end-of-an-input-with-react-js
export function moveCaretAtEnd(e) {
  const tempValue = e.target.value;
  e.target.value = '';
  e.target.value = tempValue;
}
